import React from "react";
import injectStores from "../RootStore/injectStores";
// import ScheduleGridStore from 'stores/ScheduleGridStore/ScheduleGridStore';
import { MenuButton } from "components/Button";
import { List } from "components/List";
import { ScheduleGridBodyCellProps } from "./ScheduleGrid.Types";

const styles = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #eee",
  padding: "0px",
  justifyContent: "center",
  flexDirection: "column",
};

export const RightBodyCell = injectStores(
  (props: ScheduleGridBodyCellProps) => {
    const {
      namespaceId = "",
      style,
      rowIndex,
      columnIndex,
      scheduleGridStore,
    } = props;
    // console.log('LeftBodyCell', namespaceId);
    const currentStore = scheduleGridStore?.namespaces[namespaceId];
    // console.log('currentStore', currentStore);
    const currentEntity = currentStore?.currentRows[rowIndex];
    // console.log('RightBodyCell currentEntity', currentEntity);

    const currentHeader =
      currentStore?.currentColumnHeaders?.[columnIndex] ?? null;
    // console.log('RightBodyCell currentHeader', currentHeader);

    // const LOWER_LIMIT = 2;
    const UPPER_LIMIT = 8;

    const itemsFromEntity =
      currentEntity && "entities" in currentEntity
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          currentEntity.entities.filter((entity: { [key: string]: any }) => {
            const headerKey = currentHeader?.headerKey as string;
            // console.log('RightBodyCell currentHeader.key', currentHeader?.key);
            // console.log('RightBodyCell headerKey', headerKey);
            // console.log('RightBodyCell entity', entity);

            const currentHeadKeyValue = entity[headerKey] as string;
            // console.log(
            //   'RightBodyCell currentHeadKeyValue',
            //   currentHeadKeyValue
            // );

            return (
              currentHeader &&
              headerKey &&
              headerKey in entity &&
              String(currentHeadKeyValue) === String(currentHeader.key)
            );
          })
        : [];
    // console.log('RightBodyCell itemsFromEntity', itemsFromEntity);

    if (currentHeader?.bodyComponent) {
      const Component = currentHeader.bodyComponent;
      // console.log('RightHeaderCell Component', Component);
      return React.cloneElement(<Component />, {
        currentStore,
        currentHeader,
        styles,
        itemsFromEntity,
        ...props,
      });
    }

    let buttonColor = "transparent";
    // if (
    //   itemsFromEntity.length > LOWER_LIMIT &&
    //   itemsFromEntity.length < UPPER_LIMIT
    // ) {
    //   buttonColor = 'transparent';
    // }

    if (itemsFromEntity.length >= UPPER_LIMIT) {
      buttonColor = "error";
    }

    return (
      <div
        key={`left-header-cell-${namespaceId}-${rowIndex}`}
        title={undefined}
        style={{
          ...style,
          ...styles,
          height: (typeof style?.height === "number" ? style.height : 0) - 2,
          width: (typeof style?.width === "number" ? style.width : 0) - 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <MenuButton
          fullWidth
          color={buttonColor}
          menuStyle={{ padding: 10 }}
          menu={() => {
            return (
              <List
                rows={itemsFromEntity}
                height={200}
                rowHeight={30}
                // rowCount={itemsFromEntity.length}
                width={330}
                customRowRenderer={({ rowKey, index, style }) => {
                  const item = itemsFromEntity[index];
                  return (
                    <div
                      key={rowKey}
                      style={{
                        ...style,
                        borderBottom: "1px solid black",
                        height:
                          (typeof style.height === "number"
                            ? style.height
                            : 0) - 2,
                        width: "100%",
                      }}
                    >
                      {(item as { id: string }).id}
                    </div>
                  );
                }}
              />
            );
          }}
        >
          {itemsFromEntity && (
            <b>
              {itemsFromEntity.length > 0 &&
                (itemsFromEntity[0] as { id: string }).id}
            </b>
          )}
        </MenuButton>
      </div>
    );
  }
);

export default RightBodyCell;
